import { FinanceBonusesTable } from "components/Tables/FinanceBonusesTable/FinanceBonusesTable.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getFinanceHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/finance/_layout/bonus/")({
    component: FinanceBonusPage,
    staticData: {
        permissions: [],
        //permissions: [PermissionEnum.FinanceBonusView],
        showInSideMenu: false,
        label: "pages.finance.bonus.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.finance.bonus.title"),
        };
    },
});

function FinanceBonusPage() {
    return (
        <TenantPage headerNavigationItems={getFinanceHeaderItems}>
            <FinanceBonusesTable />
        </TenantPage>
    );
}
